<template>
  <div class="index-comFooterMobile">
      <el-row>
        <el-col>
          <span class="span1">业务介绍&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;关于扬海&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;资讯中心&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;联系我们</span>
        </el-col>
        <el-col>
          <div class="mobile-border"></div>
        </el-col>
        <!-- <el-col><img src="../../assets/img/img-huiselogo.png" alt=""></el-col> -->
        <el-col><span class="span2">@2019 - 2029 扬海资产 版权所有 <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">浙ICP备2020030464号-1</a></span></el-col>
      </el-row>
  </div>
</template>
<script>
// import middleKey from "../components/middleKey.vue"; //中间件
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {}
};
</script>
<style>
.index-comFooterMobile{
  background: #ffffff;
  height:120px;
  background:rgba(247,247,247,1);
  padding: 20px;
}
.index-comFooterMobile .span1{
  font-size:14px;
font-family:Helvetica;
color:rgba(126,126,126,1);
line-height:14px;
}
.index-comFooterMobile .span2{
  font-size:12px;
font-family:Helvetica;
color:rgba(154,154,154,1);
line-height:16px;
}
.index-comFooterMobile img{
  width: 300px;
}
.index-comFooterMobile .mobile-border{
  height:2px;
  background:rgba(34,34,34,1);
  opacity:0.2;
  margin: 10px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/page/comFooterMobile.vue